import { DateUtil } from '../utils/DateUtil';
export class TermExtension {
    _quantity;
    _date;
    _description;
    _active = true;
    _id;
    _emiRecalculationMode = 'none';
    _emiRecalculationTerm;
    /**
     * If true (default), skip-a-pay periods (zero-dollar terms) are ignored when recalculating EMI for this extension.
     * If false, skip-a-pay periods are included in the term count for EMI recalculation.
     */
    _ignoreSkipTermsForEmiRecalculation = true;
    jsQuantity;
    jsDate;
    jsDescription;
    jsActive;
    jsId;
    jsEmiRecalculationMode;
    jsEmiRecalculationTerm;
    jsIgnoreSkipTermsForEmiRecalculation;
    _modified = false;
    get modified() {
        return this._modified;
    }
    set modified(v) {
        this._modified = v;
    }
    constructor(params) {
        this.quantity = params.quantity;
        this.date = params.date;
        this.description = params.description;
        this.active = params.active ?? true;
        this.id = params.id;
        this.emiRecalculationMode = params.emiRecalculationMode ?? 'none';
        this.emiRecalculationTerm = params.emiRecalculationTerm;
        this.ignoreSkipTermsForEmiRecalculation =
            params.ignoreSkipTermsForEmiRecalculation !== undefined ? params.ignoreSkipTermsForEmiRecalculation : true;
        this.updateJsValues();
    }
    get quantity() {
        return this._quantity;
    }
    set quantity(v) {
        this._quantity = v;
        this.jsQuantity = v;
        this.modified = true;
    }
    get date() {
        return this._date;
    }
    set date(v) {
        this._date = DateUtil.normalizeDate(v);
        this.jsDate = DateUtil.normalizeDateToJsDate(this._date);
        this.modified = true;
    }
    get description() {
        return this._description;
    }
    set description(v) {
        this._description = v;
        this.jsDescription = v;
        this.modified = true;
    }
    get active() {
        return this._active;
    }
    set active(v) {
        this._active = v;
        this.jsActive = v;
        this.modified = true;
    }
    get id() {
        return this._id;
    }
    set id(v) {
        this._id = v;
        this.jsId = v;
        this.modified = true;
    }
    get emiRecalculationMode() {
        return this._emiRecalculationMode;
    }
    set emiRecalculationMode(v) {
        this._emiRecalculationMode = v;
        this.jsEmiRecalculationMode = v;
        this.modified = true;
    }
    get emiRecalculationTerm() {
        return this._emiRecalculationTerm;
    }
    set emiRecalculationTerm(v) {
        this._emiRecalculationTerm = v;
        this.jsEmiRecalculationTerm = v;
        this.modified = true;
    }
    get ignoreSkipTermsForEmiRecalculation() {
        return this._ignoreSkipTermsForEmiRecalculation;
    }
    set ignoreSkipTermsForEmiRecalculation(v) {
        this._ignoreSkipTermsForEmiRecalculation = v;
        this.jsIgnoreSkipTermsForEmiRecalculation = v;
        this.modified = true;
    }
    updateJsValues() {
        this.jsQuantity = this.quantity;
        this.jsDate = DateUtil.normalizeDateToJsDate(this.date);
        this.jsDescription = this.description;
        this.jsActive = this.active;
        this.jsId = this.id;
        this.jsEmiRecalculationMode = this.emiRecalculationMode;
        this.jsEmiRecalculationTerm = this.emiRecalculationTerm;
        this.jsIgnoreSkipTermsForEmiRecalculation = this.ignoreSkipTermsForEmiRecalculation;
    }
    updateModelValues() {
        this.quantity = this.jsQuantity;
        this.date = this.jsDate;
        this.description = this.jsDescription;
        this.active = this.jsActive;
        this.id = this.jsId;
        this.emiRecalculationMode = this.jsEmiRecalculationMode;
        this.emiRecalculationTerm = this.jsEmiRecalculationTerm;
        this.ignoreSkipTermsForEmiRecalculation = this.jsIgnoreSkipTermsForEmiRecalculation;
    }
    get json() {
        return {
            quantity: this.quantity,
            date: this.date.toString(),
            description: this.description,
            active: this.active,
            id: this.id,
            emiRecalculationMode: this.emiRecalculationMode,
            emiRecalculationTerm: this.emiRecalculationTerm,
            ignoreSkipTermsForEmiRecalculation: this.ignoreSkipTermsForEmiRecalculation,
        };
    }
    toJSON() {
        return this.json;
    }
}
